import './SubscriptionFAQ.css'
import { Accordion } from '@mantine/core'

const FAQ = [
    {
        question: '¿Puedo cancelar cuando quiera?',
        answer: 'Sí, la suscripción es mensual y podés cancelarla en cualquier momento sin penalidad.',
    },
    {
        question: '¿Con qué frecuencia hay contenido nuevo?',
        answer: 'Un workshop en vivo por mes, un newsletter mensual y casos clínicos que se suman durante todo el mes.',
    },
    {
        question: '¿Los workshops quedan grabados?',
        answer: 'Sí, todos los workshops quedan disponibles en la comunidad para que los veas cuando quieras.',
    },
];

export default function SubscriptionFAQ() {
    return <div className="SubscriptionPreview-faq">
        <h3 className="SubscriptionPreview-faqTitle">Preguntas frecuentes</h3>
        <Accordion variant="separated">
            {FAQ.map((item, i) => (
                <Accordion.Item value={`faq-${i}`} key={i}>
                    <Accordion.Control styles={{
                        label: {
                            fontSize: 'var(--fs-body)'
                        }
                    }}
                    >
                        {item.question}
                    </Accordion.Control>
                    <Accordion.Panel
                        styles={{
                            content: {
                                fontSize: 'var(--fs-body)'
                            }
                        }}
                    >
                        {item.answer}
                    </Accordion.Panel>
                </Accordion.Item>
            ))}
        </Accordion>
    </div>
}